@if (years().length > 0) {
  <div class="ads-missing-years" data-testid="years-without-document">
    @for (item of years(); track trackYear(item)) {
      <section class="ads-missing-years__item" role="status">
        <header class="ads-missing-years__header">
          <span class="ads-missing-years__year">{{ item.year }}</span>
          @if (showCompanyName() && item.companyName) {
            <span class="ads-missing-years__company">{{ item.companyName }}</span>
          }
          <span class="ads-missing-years__tag">Sem documento validado</span>
        </header>
        <div class="ads-missing-years__body">
          <p class="ads-missing-years__message">{{ item.message }}</p>
          <app-button
            size="small"
            [fitContent]="true"
            [noMargin]="true"
            [theme]="item.pendingExtractionId ? 'default' : 'white'"
            [label]="item.pendingExtractionId ? 'Conferir e validar' : 'Ver documentos de ' + item.year"
            (sendClick)="onAction(item)" />
        </div>
      </section>
    }
  </div>
}
